import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormFieldAbstractComponent } from '../abstract.component';
import { provideTranslation } from '@skyeng/libs/shared/i18n';
import { FormFieldsService } from '@shared/shared';
import { TranslocoService } from '@ngneat/transloco';
import { DateTimeAdapter } from '@danielmoncada/angular-datetime-picker';

@Component({
  selector: 'crm-form-field-datetime-interval',
  templateUrl: './datetime-interval.component.html',
  styleUrls: ['./datetime-interval.component.scss'],
  viewProviders: [provideTranslation('formFieldDatetimeInterval', () => import.meta.webpackContext!('./translation'))],
})
export class FormFieldDatetimeIntervalComponent extends FormFieldAbstractComponent implements OnInit, OnDestroy {
  private readonly lang = this.transloco.getActiveLang() || this.transloco.getDefaultLang();

  dateTimeMin: Date;
  dateTimeMax: Date;
  startAt: Date;

  constructor(
    protected formFieldsService: FormFieldsService,
    private transloco: TranslocoService,
    private adapter: DateTimeAdapter<Date>,
  ) {
    super(formFieldsService);
    this.adapter.setLocale(this.lang);
  }

  ngOnInit(): void {
    super.ngOnInit();

    this.setDateRestrictions();
    this.setStartDate();
  }

  ngOnDestroy(): void {}

  private setDateRestrictions(): void {
    const minDate = this.formFieldsService.getValidatorConstraint(this.field, 'min');
    if (minDate) {
      this.dateTimeMin = minDate;
    }

    const maxDate = this.formFieldsService.getValidatorConstraint(this.field, 'max');
    if (maxDate) {
      this.dateTimeMax = maxDate;
    }
  }

  private setStartDate(): void {
    if (this.field.value == null) {
      const roundedTime = new Date();
      roundedTime.setHours(12);
      roundedTime.setMinutes(0);

      this.startAt = roundedTime;
    }
  }
}
